<template>
    <div class="bg max-content">
        <van-search v-model="keywords" :show-action="true" placeholder="请输入关键词搜索会议" shape="round" @search="onSearch">
            <template #action>
                <van-icon name="clock-o" @click="chooseDateFlag = true" size="24px"
                    style="margin-right:5px;vertical-align: middle;" color="#999999" />
                <van-icon name="filter-o" @click="sortFlag = true" size="24px"
                    style="margin-right:5px;vertical-align: middle;" color="#999999" />
            </template>
        </van-search>
        <div class="search-result" v-if="meetingList.length">
            <div class="item" v-for="item in meetingList" :key="item.id" @click="goDetail(item)">
                <div class="head">
                    <img :src="item.banner" />
                    <div class="right">
                        <p class="line-clamp-2 name">{{ item.name }}</p>
                        <p class="address" v-if="item.city && item.city.name && item.province && item.province.name">
                            地点：{{ item.province.name + " " + item.city.name }}</p>
                        <p class="address" v-else>地点：{{ item.province.name }}</p>
                    </div>
                </div>
                <div class="time">
                    <img src="@/assets/images/video_icon.png" />
                    <span>会议时间 {{ changeTimeFormat(item.start_at, item.end_at) }}</span>
                </div>
            </div>
        </div>
        <div class="empty" v-else>
            <img src="@/assets/images/System/no_meeting.png" />
            <p>暂无符合条件的会议</p>
        </div>
        <van-popup v-model="chooseDateFlag" position="bottom" round>
            <van-datetime-picker v-model="currentDate" type="year-month" title="时间" :formatter="formatter"
                @confirm="confirmDate" @cancel="chooseDateFlag = false" />
        </van-popup>
        <van-popup v-model="sortFlag" position="bottom" round style="padding:15px;">
            <div class="flex-title">
                <span class="button" @click="cancel">取消</span>
                <span class="title">排序</span>
                <span class="button active" @click="changeSort">确定</span>
            </div>
            <div class="sort-button" :class="sort_init == 'asc' ? 'active' : ''" @click="sort_init = 'asc'">从早到晚</div>
            <div class="sort-button" :class="sort_init == 'desc' ? 'active' : ''" @click="sort_init = 'desc'">从晚到早</div>
        </van-popup>
    </div>
</template>

<script>
import { MeetingsSearch } from '../../../config/interface.js'
import { Toast } from 'vant'
export default {
    data() {
        return {
            keywords: '',
            chooseDateFlag: false,
            sortFlag: false,
            currentDate: new Date(),
            sort_type: 'desc',
            sort_init: 'desc',
            meetingList: []
        }
    },
    created() {
        if (this.$route.query.keywords) {
            this.keywords = this.$route.query.keywords
        }
        this.search()
    },
    methods: {
        onSearch() {
            this.search()
        },
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            }
            return val;
        },
        confirmDate() {
            this.chooseDateFlag = false;
            console.log(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1)
            this.search('date');
        },
        //搜索
        search(type) {
            Toast.loading({
                forbidClick: true,
                duration: 0
            });
            const url = MeetingsSearch;
            const method = 'POST'
            let params = {
                sort_type: this.sort_type,
                keywords: this.keywords
            }
            if (type == 'date') {
                params['time'] = this.currentDate.getFullYear() + '-' + (this.currentDate.getMonth() + 1)
            }
            fetch(url, params, method)
                .then((res) => {
                    Toast.clear();
                    if (res.code == 0) {
                        this.meetingList = res.data
                    }
                })
        },
        changeTimeFormat(start, end) {
            let start_at = start.split(' ')[0]
            start_at = start_at.replace(/-/g, ".")
            let end_at = end.split(' ')[0]
            end_at = end_at.replace(/-/g, ".").substring(5)
            return start_at + " - " + end_at
        },
        cancel() {
            this.sortFlag = false;
            this.sort_init = this.sort_type;
        },
        changeSort() {
            this.sort_type = this.sort_init;
            this.sortFlag = false
            this.search();
        },
        goDetail(val) {
            let id = val.id
            if(val.live_url){
                window.location.href = val.live_url
                return;
            }
            if (id == 286) {
                this.$router.push({
                    path: '/CEC2022/index',
                })
            }
            else if (id == 348) {
                this.$router.push({
                    path: '/CEC2023/index',
                })
            }
            else if (id == 399) {
                this.$router.push({
                    path: '/CVSCF2023/index',
                })
            }
            else if (id == 483) {
                this.$router.push({
                    path: '/XVC/index',
                })
            }
            else {

                this.$router.push({
                    path: '/vascularNews/meeting/index',
                    query: {
                        meeting_id: id
                    }
                })
            }
        },
    }

}
</script>

<style lang="scss" scoped>
.bg {
    background: white;
    min-height: 100%;
}

.search-result {
    padding: 0 15px;
}

.search-result .item {
    padding: 15px 15px 0;
    background: #F9F9F9;
    border-radius: 10px;
    margin-bottom: 15px;

    .head {
        border-bottom: 0.5px solid #E6E6E6;
        display: flex;
        padding-bottom: 15px;

        img {
            width: 100px;
            border-radius: 5px;
        }

        .right {
            width: calc(100% - 100px);
            padding-left: 10px;

            p {
                font-size: 14px;
                color: #131313;
                line-height: 20px;
            }

            .name {
                height: 40px;
            }

            .title {
                height: 40px;
            }

            .address {
                font-size: 12px;
                color: #666666;
                line-height: 17px;
                margin-top: 5px;
            }
        }

    }

    .time {
        padding: 0 5px;
        font-size: 12px;
        color: #131313;
        line-height: 38px;

        img {
            width: 20px;
            vertical-align: middle;
            margin-right: 5px;
        }
    }
}

.empty {
    text-align: center;
    padding-top: 80px;
    color: #999999;
    font-size: 14px;

    img {
        width: 40%;
        margin-bottom: 20px;
    }
}

.flex-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;

    .button {
        font-size: 14px;
        color: #999999;
    }

    .button.active {
        font-size: 14px;
        color: #901D22;
    }

    .title {
        font-size: 18px;
        color: #141414;
    }
}

.sort-button {
    /* 矩形备份 */
    width: 200px;
    height: 46px;
    border-radius: 7px;
    background: #FFFFFF;
    border: 0.5px solid #D9D9D9;
    line-height: 46px;
    color: #141414;
    font-size: 16px;
    text-align: center;
    margin: 20px auto;
}

.sort-button.active {
    /* 矩形 */
    background: #901D22;
    border: 0.5px solid #901D22;
    line-height: 46px;
    color: #ffffff;
}
</style>>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Calendar/Search.vue